import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import QuizCreationForm from './QuizCreationForm'
import { Link, useSearchParams } from 'react-router'
import { useQuizzes } from '../../../contexts/QuizContext'
import CourseTopicSelector from '../../../components/forms/CourseTopicSelector'
import QuizDisplayCard from '../../../components/ui/QuizDisplayCard'

function QuizManagementPage() {
  const [showCreateForm, setShowCreateForm] = useState(false);
  
  let [searchParams, setSearchParams] = useSearchParams();
  
  let selectedTopic = searchParams.get('topic_id')
  const { quizzes, loading } = useQuizzes(selectedTopic)
  
  const { register, watch, getValues, formState: { errors } } = useForm({
    defaultValues: {
      topic_id: selectedTopic || ''
    }
  })


  useEffect(() => {    
    let currentTopicId = getValues('topic_id')
    if (currentTopicId) {
      setSearchParams({ 'topic_id': currentTopicId })
    }
  }, [watch('topic_id')])
  

  return (
    <div className='mt-4'>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl md:text-3xl font-oswald font-light">Quiz Management</h1>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => setShowCreateForm(!showCreateForm)}
        >
          {showCreateForm ? 'Cancel' : 'Create Quiz'}
        </button>
      </div>

      <CourseTopicSelector
        register={register}
        errors={errors}
        watch={watch}
      />

      {selectedTopic && quizzes[0]?.topic_detail?.title && (
        <div className="border-b border-base-300 pb-2 mb-6">
          <h2 className="text-2xl font-medium">
            {quizzes[0]?.topic_detail?.title}
          </h2>
        </div>
      )}

      {showCreateForm && selectedTopic && (
        <div className="mt-6">
          <QuizCreationForm 
            topic={selectedTopic} 
            onSuccess={() => setShowCreateForm(false)}
          />
        </div>
      )}

      <div className="space-y-3 mt-8 max-w-4xl">
        {loading ? (
          <div className="text-center py-4">Loading quizzes...</div>
        ) : quizzes.length === 0 ? (
          <div className="text-center py-4">No quizzes on this topic</div>
        ) : (
          quizzes.map((quiz, index) => (
            <QuizDisplayCard key={index} quiz={quiz}/>
          ))
        )}
      </div>
    </div>
  )
}

export default QuizManagementPage